import type { FaireProductEntity } from "../../entity_types/product";

export const p_mtd6kerf76: FaireProductEntity = {
  token: "p_mtd6kerf76",
  type: "product",
  name: "Middle Child Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/ea4fa6ab0d71b3708119a3b472e145a083d40f40c9b3b4792d5e0d654097b232.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/15c9bf8abb36d0a6956e261f9a8db69ff4b04ddbb373b11f83fb9c6318df53da.jpeg",
    "https://cdn.faire.com/fastly/48794d5fcb8c41c310a93254951e6a64ff2643d946c4eeae0393f3334af01397.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/b40cdf7c818d21b8213bf2574c23bb321a47ae169a169ae9e8850390d778d366.jpeg",
    "https://cdn.faire.com/fastly/8cc34cc6ba8d4d932a15e3e0e46e21c03f534339a670335736ff42a076daaf5c.jpeg",
    "https://cdn.faire.com/fastly/c2734a72b13d1593f98f445d9377a6c77b1380e51c165b560c8d247211aa7a6f.jpeg",
    "https://cdn.faire.com/fastly/fa21eab34c87199d9ac54d2973e643f4d9276745638792cb6b4ccc9764fc1c9b.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the expertly overlooked, wildly adaptable, and somehow still the most solid presence in the room.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:58.671Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
